import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { ExternalLink } from "lucide-react";

const CLASSES = {
  primary: "bg-brand text-white hover:bg-[hsl(var(--brand-red-deep))]",
  secondary: "border border-white/30 text-white hover:bg-white/10",
  light: "bg-white text-black hover:bg-white/90",
  dark: "bg-black text-white hover:bg-black/80",
};

export const SectionButton = ({ button }) => {
  if (!button || !button.label) return null;
  const cls = cn(
    "inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 text-sm font-semibold uppercase tracking-wide transition-colors duration-200",
    CLASSES[button.style] || CLASSES.primary
  );
  // Optional editor-chosen text color override (wins over the style preset's text color).
  const style = button.textColor ? { color: button.textColor } : undefined;
  const isExternal = button.external || /^https?:\/\//.test(button.href || "");
  if (isExternal) {
    return <a href={button.href || "#"} target="_blank" rel="noopener noreferrer" className={cls} style={style}>{button.label}<ExternalLink className="h-4 w-4" /></a>;
  }
  return <Link to={button.href || "#"} className={cls} style={style}>{button.label}</Link>;
};
